import { Component, Input, SimpleChanges } from '@angular/core';
import { CommunicationService } from '../../services/communication/communication.service';
import { SLOW_FADE_IN } from '../../util/animations/animation';

@Component({
  selector: 'app-advance-search',
  templateUrl: './advance-search.component.html',
  styleUrls: ['./advance-search.component.scss'],
  animations: [SLOW_FADE_IN]
})
export class AdvanceSearchComponent {
  @Input() board = '';
  labels = [];
  searchText = '';
  showAdvanceFilterDropDown = false;
  isAdvanceFiltersApplied = false;
  communicationListener;

  constructor(private communicationService: CommunicationService) {
    this.communicationListener = this.communicationService.getLabels.subscribe(labels => {
      this.labels = labels;
      // this.applyOldFilters();
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.board && changes.board.currentValue) {
      this.board = changes.board.currentValue;
      this.isAdvanceFiltersApplied = false;
      this.showAdvanceFilterDropDown = false;
      this.searchText = '';
    }
  }

  applyOldFilters() {
    this.showAdvanceFilterDropDown = false;
    this.searchText = '';

    if (this.board) {
      const allFilters = JSON.parse(localStorage.getItem('dashboard-filters'));
      if (allFilters) {
        const filter = allFilters[this.board];
        if (filter) {
          const labelFilters = filter.labels;
          if (this.labels.length&&labelFilters&&labelFilters.length) {
            this.labels.map(x => { x.selected = labelFilters.findIndex(y => y.id === x.id) !== -1});
            this.setFilter();
          }
        }
      }
    }
  }

  ngOnDestroy(): void {
    this.communicationListener.unsubscribe();
  }

  onSelectLabelItem(item) {
    this.labels.map(x => {
      if (item.id === x.id)
        x.selected = !x.selected
    })
    this.setFilter();
  }

  setFilter() {
    const labels = [];
    this.labels.map(x=> {
      if(x.selected) 
      labels.push({id: x.id, labelText: x.labelText})
    })
    const payload = {
      labels,
      searchText: this.searchText
    }
    this.communicationService.setTaskFilter(payload);
    this.isAdvanceFiltersApplied = labels.length>0;

    // if (this.board) {
    //   let allFilters = JSON.parse(localStorage.getItem('dashboard-filters'));
    //   allFilters = {
    //     ...allFilters,
    //     [this.board]: payload
    //   }
    //   localStorage.setItem('dashboard-filters', JSON.stringify(allFilters));
    // }
  }

  openAdvanceFilter() {
    this.showAdvanceFilterDropDown = !this.showAdvanceFilterDropDown;
  }
}
